import * as Constants from '../Constant';

const initialState = {
    message: {},
    treatmentList: {},
}

export default function treatmentReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_TREATMENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_TREATMENT:
            return {
                ...state,
                treatmentList: action.payload,
            }
        case Constants.UPDATE_TREATMENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_TREATMENT:
            return {
                ...state,
                message: action.payload,
            }
        default:
            return state;
    }
}